import React, { useState, useEffect, use } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import InputTextComponent from "../../../components/ui/InputText";
import LinkComponent from "../../../components/ui/Link";
import Button from "../../../components/ui/Button";
import '../style/otp_style.css';
import "../../login_v2/styles/animation.css";
import { otpActions } from "../../../di/di";
import { getUser, verifyOtp, resendOtp } from "../state/otp_slice";
import { LoginRoute } from "../../../../../core/routes/route_constants";
import VerificationSuccessfulComp from "./verification_successful_comp";

const OtpComp = () => {
    const Wave_1_2000 = "/images/wave_1_2000.png";
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [otpKey, setOtpKey] = useState("");
    const [allowToVerify, setAllowToVerify] = useState(false);

    const isVerifying = useSelector((state) => state.otp.isVerifying);
    const resendingOtp = useSelector((state) => state.otp.resendingOtp);
    const goToLogin = useSelector((state) => state.otp.goToLogin);

    const [searchParams] = useSearchParams();
    const currentUserEmail = searchParams.get('email');

    useEffect(() => {
        if(!currentUserEmail) {
            navigate(LoginRoute);
        }
        dispatch(getUser());
        return () => {
            dispatch(otpActions.resetState());
        };
    }, [dispatch]);

    useEffect(() => {
        // if(goToLogin === true) {
        //     navigate(LoginRoute);
        // }
    }, [goToLogin])

    

    const otpErrorMessage = useSelector((state) => state.otp.otpErrorMessage);

    /**
     * Resends the OTP to the user
     */
    const handleResendOtp = () => {
        /**
         * Dispatch the resend OTP action with the current user's email
         * @param {string} email - The email address of the user
         */
        dispatch(resendOtp(currentUserEmail));
    };

    /**
     * Handles the OTP input change event
     * @param {React.ChangeEvent<HTMLInputElement>} e - The event object
     */
    const handleOtpInputChanged = (e) => {
        let strOtpKey = e.target.value;
        strOtpKey = strOtpKey.trim();
        setOtpKey(strOtpKey);

        // Check if the OTP is valid
        // The OTP must be 6 digits
        // The OTP must not be empty
        // The OTP must not have any spaces
        setAllowToVerify(
            !strOtpKey || 
            (strOtpKey.length < 6 && strOtpKey.length > 0)
        );
    };

    /**
     * Handles pasting of OTP code
     * @param {React.ClipboardEvent<HTMLInputElement>} e - The clipboard event
     */
    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').trim();
        
        // Only process if pasted data is exactly 6 digits
        if (/^\d{6}$/.test(pastedData)) {
            setOtpKey(pastedData);
            setAllowToVerify(false);
        }
    };

    /**
     * Handles the verify OTP button click event
     * Dispatches the verify OTP action with the current user's email and OTP
     */
    const handleVerifyClick = () => {
        dispatch(verifyOtp({email: currentUserEmail, otp: otpKey}));
    }

    if(goToLogin){
        return <VerificationSuccessfulComp />
    }


    return (
        <div className="flex flex-row flex-grow-1 justify-content-center align-items-center bg-gradient-signup">
            {/* Wave Image */}
            <div className="register-wave-container">
                <img src={Wave_1_2000} alt="Wave Background" />
            </div>
            {/* OTP Container */}
            <div className="otp-parent">
                {/* OTP Box */}
                <div className="otp-box flex flex-column align-items-center h-auto w-25rem p-5 pt-4 px-5 border-round-lg  rounded-2xl  border-1  shadow-lg">
                    <div className="text-xl font-semibold">
                        Verify your OTP
                    </div>

                    <div className="text-base mb-3">
                        The 6 digit code has been sent to your email "{currentUserEmail}".
                    </div>
                    <div className="flex flex-column w-full mb-2 gap-1 text-base">
                        <InputTextComponent 
                            placeholder="Enter OTP" 
                            className="text-center" 
                            onChange={handleOtpInputChanged} 
                            onPaste={handleOtpPaste}
                            invalid={!otpErrorMessage} 
                            inputMode="numeric"
                        />
                        {/* Error Message */}
                        { otpErrorMessage ? <div className="register-error-message font-base flex flex-row justify-content-center align-items-center">{otpErrorMessage}</div> : null }
                    </div>
                    <div class="remember-forgot-container mt-1 mb-3 justify-content-between align-items-center">

                        <LinkComponent label="Didn't received the code?" className="text-white no-underline txt-forgot-password" onClick={handleResendOtp} loading={resendingOtp} />

                    </div>
                    <div className="flex flex-column w-full mb-4 gap-1">
                        <Button label={isVerifying ? "Verifying..." : "Verify"} className="custom-start-button" disabled={allowToVerify} onClick={handleVerifyClick} loading={isVerifying} />
                    </div>
                </div>
            </div>
        </div>
    );
};


export default OtpComp;